import Cookies from 'js-cookie'

const COOKIE_NAME = 'refTracking'

/**
 * Enum for supported promo codes
 * Add new promo codes here as they are introduced
 */
export const PromoCode = {
  NADA2026: 'NADA2026',
  '10KBONUS': '10KBONUS',
}

/**
 * Cookie data structure (refTracking):
 * {
 *   source: string,
 *   path: string,
 *   parameters: object,
 *   promoCode?: string  // e.g., "NADA2026"
 * }
 */

/**
 * Get the refTracking cookie and parse it
 * @returns {Object|null} Cookie data or null if not found/invalid
 */
const getRefTrackingCookie = () => {
  try {
    const cookieValue = Cookies.get(COOKIE_NAME)
    if (!cookieValue) {
      return null
    }

    const jsonString = atob(cookieValue)
    const cookieData = JSON.parse(jsonString)

    return cookieData
  } catch (error) {
    // Invalid cookie format
    console.error('Error reading refTracking cookie:', error)
    return null
  }
}

/**
 * Check if a specific promo code is set in the cookie
 * @param {string} promoCode - The promo code to check (use PromoCode enum)
 * @returns {boolean} True if the specified promo code is set in the cookie
 */
export const hasPromoCookie = (promoCode) => {
  if (!promoCode) {
    return false
  }
  const cookieData = getRefTrackingCookie()
  if (!cookieData?.promoCode) {
    return false
  }
  // Uppercase both values for case-insensitive comparison
  const cookiePromoCode = cookieData.promoCode.toUpperCase()
  const upperPromoCode = promoCode.toUpperCase()
  return cookiePromoCode === upperPromoCode
}
